import angular from "angular";
import template from "./pay-ratios.html";
import AdminSettingsPoliciesPayRatiosController from "./pay-ratios.controller";

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.admin.settings.policies.payratios", {
    url: "/pay-ratios",
    controller: AdminSettingsPoliciesPayRatiosController,
    controllerAs: "vm",
    template: template,
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.owner,
        USER_ROLES.administrator,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.settings.policies.payratios", [])
  .controller(
    "AdminSettingsPoliciesPayRatiosController",
    AdminSettingsPoliciesPayRatiosController,
  )
  .config(config);
